    import React, { PropsWithChildren, useState } from 'react';
    import { Layout, Menu, Tooltip } from 'antd';
    import { useTranslation } from 'react-i18next';
    import { Link } from '@inertiajs/react';
    import { Blogger, Buildings2, Building, GlobalRefresh, GlobalSearch, Home2, ProfileCircle, SliderHorizontal, VideoAdd, ArchiveBook, Autobrightness, Polkadot, Key, Cup, MessageQuestion, FolderAdd, Bag2, ArchiveAdd, Ankr, Book1, Hospital, Call, Health, Bookmark } from 'iconsax-react';
    import mobawon from '@/../../public/footer/logo-no-background.png';
    const { Sider, Footer } = Layout;
    import { User } from '@/types';
    // interface SideBarProps {
    //   children: React.ReactNode;
    // }

    export default function SideBar({ children, user }: PropsWithChildren<{ user: User }>) {
        const [collapsed, setCollapsed] = useState(false);
        const { t, i18n } = useTranslation(); // Use the i18next hook for translations

        const menuItems = [
            {
                key: '1',
                icon: <Home2 size="24" color="#BEE0FF" />,
                label: <Link className='font-sans' href={route(`${user.roles}.dashboard`, { locale: i18n.language })}>{t('sidebar.home')}</Link>,
            },
            {
                key: '2',
                icon: <Blogger size="24" color="#BEE0FF" />,
                label: <Link className='font-sans' href={route(`${user.roles}.blogs.index`, { locale: i18n.language })}>{t('sidebar.blogs')}</Link>,
            },
            {
                key: '3',
                icon: <VideoAdd size="24" color="#BEE0FF" />,
                label: <Link className='font-sans' href={route(`${user.roles}.podcast.index`, { locale: i18n.language })}>{t('sidebar.podcast')}</Link>,
            },
            {
                key: 'sub1',
                icon: <Buildings2 size="24" color="#BEE0FF" />,
                label: <p className='font-sans'>{t('sidebar.mangebranches')}</p>,
                children: [

                    {
                        key: '5',
                        icon: <Building size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.maindepartment.index`, { locale: i18n.language })}>{t('sidebar.departments')}</Link>,
                    },
                    {
                        key: '6',
                        icon: <ProfileCircle size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.doctors.index`, { locale: i18n.language })}>{t('sidebar.doctors')}</Link>,
                    },
                ],
            },
            {
                key: 'sub2',
                icon: <GlobalRefresh size="24" color="#BEE0FF" />,
                label: <p className='font-sans'>{t('sidebar.manageweb')}</p> ,
                children: [
                    {
                        key: '7',
                        icon: <SliderHorizontal size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.slide.index`, { locale: i18n.language })}>{t('sidebar.slides')}</Link>,
                    },
                    {
                        key: 'sub2_7',
                        icon: <Bookmark size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.magazine.index`, { locale: i18n.language })}>{t('sidebar.magazine')}</Link>,
                    },
                    {
                        key: '8',
                        icon: <MessageQuestion size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.faq.index`, { locale: i18n.language })}>{t('sidebar.Faq')}</Link>,
                    },
                    {
                        key: 'sub3',
                        icon: <ArchiveAdd size="24" color="#BEE0FF" />,
                        label: <p className='font-sans'>{t('sidebar.jobs')}</p>,
                        children: [
                            {
                                key: '9',
                                icon: <FolderAdd size="24" color="#BEE0FF" />,
                                label: <Tooltip title={t('sidebar.jobtype')} placement='right'> <Link className='font-sans'href={route(`${user.roles}.jobcareertype.index`, { locale: i18n.language })}>{t('sidebar.jobtype')}</Link> </Tooltip>,
                            },
                            {
                                key: '10',
                                icon: <Bag2 size="24" color="#BEE0FF" />,
                                label: <Tooltip title={t('sidebar.add_job')} placement='right'> <Link className='font-sans'href={route(`${user.roles}.jobcareer.index`, { locale: i18n.language })}>{t('sidebar.add_job')}</Link> </Tooltip>,
                            },

                        ]
                    },
                    {
                        key: '11',
                        icon: <Ankr size="24" color="#BEE0FF" />,
                        label: <Tooltip title={t('sidebar.insuarance')} placement='right'> <Link className='font-sans'href={route(`${user.roles}.insuarance.index`, { locale: i18n.language })}>{t('sidebar.insuarance')}</Link> </Tooltip>,
                    },
                    {
                        key: '12',
                        icon: <Cup size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.possibility.index`, { locale: i18n.language })}>{t('sidebar.possibil')}</Link>,
                    },
                    {
                        key: '13',
                        icon: <GlobalSearch size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.social.index`, { locale: i18n.language })}>{t('sidebar.socialmedia')}</Link>,
                    },
                    {
                        key: '14',
                        icon: <Book1 size="24" color="#BEE0FF" />,
                        label: <Tooltip title={t('sidebar.medicalnews')} placement='right'> <Link className='font-sans'href={route(`${user.roles}.medicalnews.index`, { locale: i18n.language })}>{t('sidebar.medicalnews')}</Link> </Tooltip>,
                    },
                    {
                        key: '15',
                        icon: <Hospital size="24" color="#BEE0FF" />,
                        label: <Tooltip title={t('sidebar.offers')} placement='right'> <Link className='font-sans'href={route(`${user.roles}.offers.index`, { locale: i18n.language })}>{t('sidebar.offers')}</Link> </Tooltip>,
                    },
                    {
                        key: 'sub2_15',
                        icon: <Health size="24" color="#BEE0FF" />,
                        label: <Tooltip title={t('sidebar.humanbody')} placement='right'> <Link className='font-sans'href={route(`${user.roles}.humanbody.index`, { locale: i18n.language })}>{t('sidebar.humanbody')}</Link> </Tooltip>,
                    },
                ],
            },
            {
                key: 'sub4',
                icon: <ArchiveBook size="24" color="#BEE0FF" />,
                label: <p className='font-sans'>{t('sidebar.aboutus')}</p>,
                children: [
                    {
                        key: '16',
                        icon: <Autobrightness size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.aboutus.index`, { locale: i18n.language })}>{t('sidebar.howus')}</Link>,
                    },
                    {
                        key: 'sub4_16',
                        icon: <Autobrightness size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.ourhistory.index`, { locale: i18n.language })}>{t('sidebar.ourhistory')}</Link>,
                    },
                    {
                        key: '17',
                        icon: <Autobrightness size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.management.index`, { locale: i18n.language })}>{t('sidebar.management')}</Link>,
                    },
                    {
                        key: '18',
                        icon: <Autobrightness size="24" color="#BEE0FF" />,
                        label: <Link className='font-sans'href={route(`${user.roles}.achievement.index`, { locale: i18n.language })}>{t('sidebar.achievement')}</Link>,
                    },
                    {
                        key: '19',
                        icon: <Call size="24" color="#BEE0FF" />,
                        label: <Tooltip title={t('sidebar.hospitalnumber')} placement='right'> <Link className='font-sans'href={route(`${user.roles}.hospitalnumber.index`, { locale: i18n.language })}>{t('sidebar.hospitalnumber')}</Link> </Tooltip>,
                    },


                ]
            },
            ...(user.roles === 'Admin' ?
                [{
                    key: '20',
                    icon: <Autobrightness size="24" color="#BEE0FF" />,
                    label: <Link className='font-sans'href={route(`${user.roles}.staff.index`, { locale: i18n.language })}>{t('sidebar.staff')}</Link>,
                }]
                :
                []
            ),
            {
                key: '21',
                icon: <Autobrightness size="24" color="#BEE0FF" />,
                label: <Link className='font-sans'href={route(`${user.roles}.joboffer.index`, { locale: i18n.language })}>{t('sidebar.jopoffer')}</Link>,
            },
            {
                key: '22',
                icon: <Autobrightness size="24" color="#BEE0FF" />,
                label: <Link className='font-sans'href={route(`${user.roles}.appointmentoffer.index`, { locale: i18n.language })}>{t('sidebar.appointement')}</Link>,
            },
            {
                key: '23',
                icon: <Autobrightness size="24" color="#BEE0FF" />,
                label: <Link className='font-sans'href={route(`${user.roles}.offerrequests.index`, { locale: i18n.language })}>{t('sidebar.orderoffers')}</Link>,
            },
            {
                key: '24',
                icon: <Autobrightness size="24" color="#BEE0FF" />,
                label: <Link className='font-sans'href={route(`${user.roles}.patientexperince.index`, { locale: i18n.language })}>{t('sidebar.patientexperince')}</Link>,
            },
            {
                key: '25',
                icon: <Autobrightness size="24" color="#BEE0FF" />,
                label: <Link className='font-sans'href={route(`${user.roles}.contactus.index`, { locale: i18n.language })}>{t('sidebar.contactus')}</Link>,
            },
            {
                key: '26',
                icon: <Autobrightness size="24" color="#BEE0FF" />,
                label: <Link className='font-sans'href={route(`${user.roles}.disease.index`, { locale: i18n.language })}>{t('sidebar.disease')}</Link>,
            },

        ]



        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Sider
                    theme="light"
                    collapsible
                    collapsed={collapsed}
                    onCollapse={(value) => setCollapsed(value)}
                >
                    <Menu theme="light" defaultSelectedKeys={['1']} mode="inline" items={menuItems} />
                </Sider>
                <Layout>
                    <main className="flex-1">{children}</main>
                    <Footer style={{ textAlign: 'center' }}>
                        <div className='flex justify-center items-center flex-col my-5 font-sans'>
                            <a href="https://direct.me/dmcreators" target='_blank'>
                                <img loading='lazy' src={mobawon} className='object-cover w-32' />
                            </a>
                            <p className='py-2'>
                                {t('footer.mobdwon')}
                                <a href='https://direct.me/dmcreators' target='_blank'>{t('footer.mobdwon_link')}</a>
                                ©{new Date().getFullYear()}
                            </p>
                        </div>


                    </Footer>
                </Layout>
            </Layout>
        );
    };

    // export default SideBar;
